module.exports = __webpack_public_path__ + "img/Logo.c886e41c.svg";